<template>
  <v-container>
    <div
      class="mt-5"
      :class="{'mx-10': $vuetify.breakpoint.lgAndUp}"
      style="border:1px solid black"
    >
      <v-tabs
        ref="tabs"
        v-model="active"
        align-with-title
        slider-color="white"
        show-arrows
      >
        <v-tab
          v-for="item in filteredTabItems"
          :key="item.name"
          class="divider font-black"
        >
          {{ item.name }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="active">
        <v-tab-item
          v-if="$hasPermissionTo(['view type of misconducts'])"
          class="pb-12"
        >
          <setup-disciplines-type-of-misconduct-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view disciplinary actions'])"
          class="pb-12"
        >
          <setup-disciplines-disciplinary-action-container-view />
        </v-tab-item>
        
        <v-tab-item
          v-if="$hasPermissionTo(['view disciplinary categories'])"
          class="pb-12"
        >
          <setup-disciplines-disciplinary-category-container-view />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupDisciplinesDisciplinaryCategoryContainerView: () => import('@/components/hris/setup/disciplines/disciplinary-category/ContainerView'),
      SetupDisciplinesDisciplinaryActionContainerView: () => import('@/components/hris/setup/disciplines/disciplinary-action/ContainerView'),
      SetupDisciplinesTypeOfMisconductContainerView: () => import('@/components/hris/setup/disciplines/type-of-misconduct/ContainerView'),
    },
    metaInfo () {
      return {
        title: 'Job Position Setups',
      }
    },
    data () {
      return {
        tabItems: [ ],
        active: null,
      }
    },

    computed: {   
      filteredTabItems () {
        let modifiedTab = [...this.tabItems]
        
        if (this.$hasPermissionTo(['view type of misconducts'])) {
          modifiedTab.push({ name: 'Type of Misconducts' })
        }

        if (this.$hasPermissionTo(['view disciplinary actions'])) {
          modifiedTab.push({ name: 'Disciplinary Actions' })
        }

        if (this.$hasPermissionTo(['view disciplinary categories'])) {
          modifiedTab.push({ name: 'Disciplinary Category' })
        }

        return modifiedTab
      },
    },
  }
</script>

<style scoped>
.divider { 
  border-right: 1px solid #707070;
  border-bottom: 1px solid #707070;
} 

.font-black{
  color:black !important;
}

.divider.font-black.v-tab.v-tab--active{
  border-bottom:0px;
}

.v-tab {
  text-transform: none !important;
  max-height: 33px;
}
</style>
